import { render } from "./WebStory.vue?vue&type=template&id=074ed1da&scoped=true"
import script from "./WebStory.vue?vue&type=script&lang=js"
export * from "./WebStory.vue?vue&type=script&lang=js"

import "./WebStory.vue?vue&type=style&index=0&id=074ed1da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074ed1da"]])

export default __exports__